import { createFileRoute } from "@tanstack/react-router";
import { HelmCompass } from "@/components/helm-logo";

export const Route = createFileRoute("/privacy")({
	component: PrivacyPage,
});

function PrivacyPage() {
	return (
		<div className="min-h-screen bg-background">
			<header className="border-b border-border">
				<div className="max-w-3xl mx-auto px-6 py-4 flex items-center gap-3">
					<HelmCompass size={24} color="hsl(22 82% 31%)" strokeWidth={1.2} />
					<span
						className="font-display text-sm"
						style={{ letterSpacing: "0.18em" }}
					>
						H E L M
					</span>
				</div>
			</header>

			<main className="max-w-3xl mx-auto px-6 py-12 prose prose-neutral dark:prose-invert">
				<h1>Privacy Policy</h1>
				<p className="text-muted-foreground text-sm">
					Version 1.0 &mdash; Last Updated: March 15, 2026
				</p>

				<h2>1. Information We Collect</h2>
				<p>
					We collect information you provide directly to us, including your name,
					email address, phone number, and any other information you choose to
					provide when creating an account or using the Service.
				</p>

				<h2>2. How We Use Your Information</h2>
				<p>We use the information we collect to:</p>
				<ul>
					<li>Provide, maintain, and improve the Service</li>
					<li>
						Send you technical notices, updates, and administrative messages
					</li>
					<li>Respond to your comments, questions, and requests</li>
					<li>Monitor and analyze trends, usage, and activities</li>
					<li>Detect, investigate, and prevent fraudulent transactions</li>
				</ul>

				<h2>3. Information Sharing</h2>
				<p>
					We do not sell your personal information. We may share information with
					third-party service providers who perform services on our behalf, such
					as hosting, analytics, and email delivery.
				</p>

				<h2>4. Data Security</h2>
				<p>
					We take reasonable measures to help protect information about you from
					loss, theft, misuse, and unauthorized access, disclosure, alteration,
					and destruction.
				</p>

				<h2>5. Data Retention</h2>
				<p>
					We retain your information for as long as your account is active or as
					needed to provide you services. Certain records, including terms of
					service acceptance logs, are retained for a minimum of seven (7) years
					for legal compliance purposes.
				</p>

				<h2>6. Your Rights</h2>
				<p>
					You may access, correct, or delete your personal information by
					contacting us. You may also opt out of certain communications.
				</p>

				<h2>7. Changes to This Policy</h2>
				<p>
					We may update this Privacy Policy from time to time. When we do, we
					will update the version number and date above and notify you through
					the Service.
				</p>

				<h2>8. Contact Us</h2>
				<p>
					If you have questions about this Privacy Policy, please contact us at{" "}
					<a
						href="mailto:legal@americamajority.org"
						className="text-primary underline"
					>
						legal@americamajority.org
					</a>
					.
				</p>
			</main>
		</div>
	);
}
